import React from 'react'
import PropTypes from 'prop-types'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_AdviserProfiles.scss'
import { Row, Col, Table, Form } from 'react-bootstrap'
import SearchButton from '../../../../common/Buttons/SearchButton'
import SubmitSpinner from '../../../../common/Spinners/SubmitSpinner'
import Pager from '../../../../common/Pager'
import PrimaryActionButton from '../../../../common/Buttons/PrimaryActionButton'
import FieldGroup from '../../../../common/forms/FieldGroup'

const PAGE_SIZE = 15

const renderAdviser = (adviser, index, submittingAdviser, submittedAdviser, setAdviser, adviserIndex, statusCodes) => {
  return <tr key={index}>
    <td>{adviser.ifaCode}</td>
    <td>{adviser.firstName} {adviser.lastName}</td>
    <td>{statusCodes.map((code, indexCode) => {
      if (code.statusCodeId === adviser.adviserStatusCodeId) {
        return <span key={indexCode} className={styles['active-status-code'] + ' ' + styles['status-description']}>{code.statusCodeDescription}</span>
      }
      return <a key={indexCode} target='blank' onClick={() => { setAdviser(code.statusCodeId) }} className={styles['status-description']}>{code.statusCodeDescription}</a>
    })}
      {adviserIndex === index && submittingAdviser && <SubmitSpinner className={styles['inline-block']} />}
    </td>
  </tr>
}

const onSearch = (event, fetchProfiles, searchTerm) => {
  event.preventDefault()
  fetchProfiles(searchTerm)
}

const onClear = (setSearchTerm, fetchAllAdvisers) => {
  setSearchTerm('')
  fetchAllAdvisers()
}

const AdviserProfiles = ({
  advisers
, adviserStatusCodes
, submittingAdviser
, submittedAdviser
, adviserIndex
, searchTerm
, setAdviser
, setSearchTerm
, fetchBySearchTerm
, fetchAllAdvisers
, addIfa
}) => {
  const [currentPage, setCurrentPage] = React.useState(1)
  // Reset to page 1 when the result-set size changes so we never land on a page that no longer exists
  React.useEffect(() => { setCurrentPage(1) }, [advisers.length])

  const totalPages = Math.ceil(advisers.length / PAGE_SIZE)
  const safePage = Math.min(currentPage, Math.max(totalPages, 1))
  const startIndex = (safePage - 1) * PAGE_SIZE
  const pagedAdvisers = advisers.slice(startIndex, startIndex + PAGE_SIZE)

  return <div>
    <Row>
      <Col xs={12} className="d-none d-sm-block">
        <h1 className={styles['heading']}>Advisers</h1>
      </Col>
    </Row>
    <Row>
      <Col sm={9} md={9} lg={9} className="d-none d-sm-block">
        <Form
          onSubmit={(event) => { onSearch(event, fetchBySearchTerm, searchTerm) }}
          className={styles['search-form']}
        >
          <FieldGroup
            value={searchTerm || ''}
            handleChange={setSearchTerm}
            placeholder={'Search profiles'}
          />
          <SearchButton buttonClassName={`${styles['inline-block']} primary-action-button`} />
          <button type="button" className={styles['clear-button']} onClick={() => onClear(setSearchTerm, fetchAllAdvisers)}>Clear</button>
        </Form>
      </Col>
      <Col sm={3} md={3} lg={3} className={`d-none d-sm-block ${styles['text-right']}`}>
        <PrimaryActionButton
          className={styles['inline-block']}
          onClick={addIfa}
          preventDefault
          buttonText='Add Adviser'
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} md={12} lg={12} className="d-none d-sm-block">
        <Table striped size='sm' bordered hover>
          <thead>
            <tr>
              <th>IFA Code</th>
              <th>Name &amp; Surname</th>
              <th className={styles['fixed-width']}>Status</th>
            </tr>
          </thead>
          <tbody>
            {pagedAdvisers.map((adviser, i) => {
              const actualIndex = startIndex + i
              return renderAdviser(adviser, actualIndex, submittingAdviser, submittedAdviser, (statusCode) => setAdviser(statusCode, actualIndex), adviserIndex, adviserStatusCodes)
            })}
          </tbody>
        </Table>
        <Pager totalPages={totalPages} currentPage={safePage} loadPage={setCurrentPage} />
      </Col>
    </Row>
  </div>
}

AdviserProfiles.propTypes = {
  advisers: PropTypes.array.isRequired,
  adviserStatusCodes: PropTypes.array.isRequired,
  submittingAdviser: PropTypes.bool.isRequired,
  submittedAdviser: PropTypes.bool.isRequired,
  adviserIndex: PropTypes.number.isRequired,
  searchTerm: PropTypes.string,
  setAdviser: PropTypes.func.isRequired,
  setSearchTerm: PropTypes.func.isRequired,
  fetchBySearchTerm: PropTypes.func.isRequired,
  fetchAllAdvisers: PropTypes.func.isRequired,
  addIfa: PropTypes.func.isRequired
}

export default  (AdviserProfiles)
